// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1gVUp","actionsCol":"EnrolledClinics_actionsCol__JPBfy"};